var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0016 8.25C19.2443 8.25 20.2516 9.25736 20.2516 10.5V18C20.2516 19.2426 19.2443 20.25 18.0016 20.25H10.5016C9.25901 20.25 8.25165 19.2426 8.25165 18V10.5C8.25165 9.25736 9.25901 8.25 10.5016 8.25H18.0016ZM10.5016 9.75C10.0874 9.75 9.75165 10.0858 9.75165 10.5V18C9.75165 18.4142 10.0874 18.75 10.5016 18.75H18.0016C18.4159 18.75 18.7516 18.4142 18.7516 18V10.5C18.7516 10.0858 18.4159 9.75 18.0016 9.75H10.5016Z",
    fill: "#727272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5016 3.75C14.7409 3.75 15.7516 4.76079 15.7516 6C15.7516 6.41421 15.4159 6.75 15.0016 6.75C14.5874 6.75 14.2516 6.41421 14.2516 6C14.2516 5.58921 13.9124 5.25 13.5016 5.25H6.00165C5.59086 5.25 5.25165 5.58921 5.25165 6V13.5C5.25165 13.9108 5.59086 14.25 6.00165 14.25C6.41586 14.25 6.75165 14.5858 6.75165 15C6.75165 15.4142 6.41586 15.75 6.00165 15.75C4.76243 15.75 3.75165 14.7392 3.75165 13.5V6C3.75165 4.76079 4.76243 3.75 6.00165 3.75H13.5016Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f08ea4e89350c2bf268a0274654f1232.svg";
export { ForwardRef as ReactComponent };